import { useState, useCallback } from "react";
import { useAuth } from "@/App";

/**
 * useLoginGuard
 * Returns { requireLogin, dialogOpen, setDialogOpen, dialogMessage }
 *
 * Usage:
 *   const { requireLogin, dialogOpen, setDialogOpen, dialogMessage } = useLoginGuard();
 *   <LoginRequiredDialog open={dialogOpen} onOpenChange={setDialogOpen} message={dialogMessage} />
 *   <button onClick={() => requireLogin(() => doThing(), "Login to apply for loan")}>...</button>
 */
export const useLoginGuard = () => {
  const { user, token } = useAuth();
  const [dialogOpen, setDialogOpen] = useState(false);
  const [dialogMessage, setDialogMessage] = useState("");

  const requireLogin = useCallback(
    (callback, message) => {
      if (user && token) {
        if (typeof callback === "function") callback();
        return true;
      }
      setDialogMessage(message || "");
      setDialogOpen(true);
      return false;
    },
    [user, token]
  );

  return { requireLogin, dialogOpen, setDialogOpen, dialogMessage };
};
